import { DatePipe } from '@angular/common';
import { Component, ViewChild, HostListener, HostBinding } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { Router } from '@angular/router';
import { error } from 'highcharts';
import { ToastrService } from 'ngx-toastr';
import { ToasterMessages } from 'src/app/shared/constants/constants';
import {
  getmonths,
  getShipNameOptions,
  gettypeofreport,
  getvesselname,
} from 'src/app/shared/helpers/dropdown-options';
import { CargoheatingCommonService } from 'src/app/shared/service/cargo-heating-service/cargoheating-common.service';
import {
  isValidHeatPlanApiPayload,
  parseHeatPlanApiToView,
} from '../../../heat-plan-graph/heat-plan-graph-parser.util';
import { OverlapService } from 'src/app/shared/service/overlapService/overlap.service';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';
import { DEMO_VESSEL_IMOS } from 'src/app/shared/helpers/heating-table-dynamic-extract.util';
@Component({
  selector: 'app-reports-table',
  templateUrl: './reports-table.component.html',
  styleUrls: ['./reports-table.component.scss'],
})
export class ReportsTableComponent {
  @ViewChild(MatSort) sort!: MatSort;
  activeReportTab: string = 'heat-plans';
  myreportForm: FormGroup;
  monthOptions: any;
  shipnameoptions: any;
  vesselnameoptions: any;
  paginatedData: any[] = [];
  currentPage: number = 0;
  itemsPerPage: number = 25;
  elements: any[];
  vesselNameSuggestions: any[] = [];
  tableData: any[] = [];
  isLoading: boolean = true;
  typeofreportoptions: string[];
  username: any;
  isClientLogin = false;
  downloadingKey: string | null = null;
  downloadingReportName: string = '';

  reportOptions = [
    {
      label: 'Average Temp Forecast',
      value: 'avg_temp_forecast',
      icon: 'device_thermostat',
      desc: 'Voyage temperature trend analysis',
      color: '#38bdf8'
    },
    {
      label: 'Tank Temp Forecast',
      value: 'tank_temp_forecast',
      icon: 'grid_view',
      desc: 'Individual tank heating breakdown',
      color: '#818cf8'
    },
    {
      label: 'Heat Plan',
      value: 'heat_plan',
      icon: 'local_fire_department',
      desc: 'Operational heating schedule & log',
      color: '#fb923c'
    },
    {
      label: 'Bunker Report',
      value: 'bunker_forecast',
      icon: 'local_gas_station',
      desc: 'Bunker consumption & savings',
      color: '#34d399'
    },
  ];

  selectedReport: string = '';

  // Modern Filter State
  vesselSearchQuery: string = '';
  monthSearchQuery: string = '';
  vesselDropdownOpen = false;
  monthDropdownOpen = false;
  selectedVessels: string[] = [];
  vesselOptions: string[] = [];
  isLoadingHeatPlanGraph = false;
  loginPic: any;

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private commonService: CargoheatingCommonService,
    private router: Router,
    private datePipe: DatePipe,
    private overlayService: OverlapService,
    private requestFormService: RequestFormService,
  ) {
    this.myreportForm = this.fb.group({
      vesselname: [''],
      typeofreport: [''],
      from_date: ['', [Validators.required]],
      to_date: ['', [Validators.required]],
      month: ['', Validators.required],
      vesselIMO: ['', [Validators.required, Validators.pattern('^[0-9]*$')]],
    });

    this.monthOptions = getmonths();
    this.shipnameoptions = getShipNameOptions();
    this.vesselnameoptions = getvesselname();
    this.typeofreportoptions = gettypeofreport();

    this.elements = this.tableData;

    this.paginateData();
  }
  activeSort: Sort = { active: '', direction: '' };

  ngOnInit(): void {
    this.username = localStorage.getItem('username');
    this.loginPic = localStorage.getItem('loginPic');
    this.isClientLogin = this.commonService.isCargoHeatingClientLogin(
      this.username,
    );
    this.fetchReportTableData();
  }
  ngAfterViewInit() {
    if (this.sort) {
      this.sort.sortChange.subscribe((sort: Sort) => {
        this.sortData(sort);
      });
    }
  }

  applyReportSelection() {
    if (this.selectedReport) {
      console.log('Selected report:', this.selectedReport);
    } else {
      alert('Please select a report option.');
    }
  }

  sortData(sort: Sort) {
    this.activeSort = sort;
    if (!sort.active || sort.direction === '') {
      this.filterClick(false);
      return;
    }

    const isAsc = sort.direction === 'asc';
    this.elements.sort((a, b) => {
      const valueA = a[sort.active];
      const valueB = b[sort.active];

      if (valueA == null || valueA === '') return isAsc ? 1 : -1;
      if (valueB == null || valueB === '') return isAsc ? -1 : 1;

      if (typeof valueA === 'string' && typeof valueB === 'string') {
        return (
          valueA.localeCompare(valueB, undefined, {
            numeric: true,
            sensitivity: 'base',
          }) * (isAsc ? 1 : -1)
        );
      }

      return (valueA < valueB ? -1 : 1) * (isAsc ? 1 : -1);
    });
    this.paginateData();
  }
  filterShipNames(event: Event): void {
    const inputValue = (event.target as HTMLInputElement).value;
    if (inputValue.length > 0) {
      this.vesselNameSuggestions = this.elements
        .filter((item: any) =>
          item.ship_name.toLowerCase().includes(inputValue),
        )
        .filter(
          (item, index, self) =>
            index === self.findIndex((t) => t.ship_name === item.ship_name),
        );
    } else {
      this.vesselNameSuggestions = [];
    }
    console.log(this.vesselNameSuggestions, 'sugges');
  }

  fetchReportTableData(): void {
    this.isLoading = true;

    this.commonService.getreportTableData().subscribe(
      (data) => {
        this.tableData = this.commonService.filterDataByClient(
          data,
          this.username,
        );
        if (this.loginPic === 'demo') {
          this.elements = this.tableData
            .filter((vessel: any) =>
              DEMO_VESSEL_IMOS.includes(String(vessel.ship_imo)),
            )
            .map((vessel: any, index: number) => ({
              ...vessel,
              ship_imo: 'XXXXXXX',
              ship_name:
                String(vessel.ship_imo) === '9312133' ? 'Vessel 1' : 'Vessel 2',
            }));
        } else {
          this.elements = this.tableData;
        }
        this.isLoading = false;

        console.log(this.elements, 'Filtered Data for Table');
        this.vesselOptions = Array.from(
          new Set(this.tableData.map((d: any) => d.ship_name).filter(Boolean)),
        ).sort() as string[];
        this.paginateData();
      },
      (error: any) => {
        console.error('Error fetching table data:', error);
        this.isLoading = false;
      },
    );
  }
  // fetchReportTableData(): void {
  //   this.isLoading = true;

  //   this.commonService.getreportTableData().subscribe(
  //     (data) => {
  //       this.tableData = data;
  //       this.isLoading = false;
  //       this.elements = this.tableData;
  //       console.log(this.elements, "hiui")
  //       this.paginateData();
  //     },
  //     (error: any) => {
  //       console.error('Error fetching table data:', error);
  //       this.isLoading = false;
  //     }
  //   );
  // }

  openHeatPlanGraph(row: any): void {
    if (!row) {
      return;
    }
    const graphRow = { ...row };
    this.isLoadingHeatPlanGraph = true;
    this.commonService.clearHeatPlanGraphPayload();
    this.commonService.setHeatPlanGraphRow(graphRow);

    this.commonService.fetchHeatPlanChartRow(graphRow).subscribe({
      next: (apiData) => {
        this.isLoadingHeatPlanGraph = false;
        try {
          if (!isValidHeatPlanApiPayload(apiData, graphRow)) {
            this.toastr.warning(
              'Heat Plan could not be read fully. On the graph screen, use Load from Excel.',
            );
            this.commonService.clearHeatPlanGraphPayload();
          } else {
            parseHeatPlanApiToView(apiData, graphRow);
            this.commonService.setHeatPlanGraphPayload(apiData);
          }
          this.router.navigate(['/ch-heatPlanGraph'], {
            state: { row: graphRow },
          });
        } catch {
          this.commonService.clearHeatPlanGraphPayload();
          this.toastr.error(
            'Could not parse Heat Plan. Use Load from Excel on the graph screen.',
          );
          this.router.navigate(['/ch-heatPlanGraph'], {
            state: { row: graphRow },
          });
        }
      },
      error: (err: Error) => {
        this.isLoadingHeatPlanGraph = false;
        this.toastr.error(
          err?.message ||
          'Could not load Heat Plan for graph. Use a row where Heat Plan download works.',
        );
      },
    });
  }

  onReportSelect(selectedType: string, row: any) {
    row.selectedReport = selectedType; // Save last selected report per row
    const reportObj = this.reportOptions.find((r) => r.value === selectedType);
    this.downloadingReportName = `${reportObj ? reportObj.label : 'Report'} · ${row.ship_name || 'Vessel'}`;
    const key = `${row.ship_imo}_${row.hp_np}_${row.voyage_no}`;
    this.downloadingKey = key;
    row.isDownloading = true;

    const payload = {
      report_type: selectedType,
      vessel_imo: row.ship_imo,
      hp_number: row.hp_np,
      voyage_no: row.voyage_no,
    };

    console.log('API Payload:', payload);

    this.commonService.printPdf(payload).subscribe({
      next: (response: any) => {
        row.isDownloading = false;
        this.downloadingKey = null;
        this.overlayService.showPdf(response);
      },
      error: () => {
        row.isDownloading = false;
        this.downloadingKey = null;
        this.toastr.info(ToasterMessages.RecordNotFount);
      },
    });
  }

  paginateData() {
    const startIndex = this.currentPage * this.itemsPerPage;
    this.paginatedData = this.elements?.slice(
      startIndex,
      startIndex + this.itemsPerPage,
    );
  }
  onPageChange(event: PageEvent) {
    this.currentPage = event.pageIndex;
    this.itemsPerPage = event.pageSize;
    this.paginateData();
  }
  goBack() {
    const landingRoute = this.isClientLogin
      ? this.commonService.getCargoHeatingClientLandingRoute()
      : '/ch-graph';
    this.router.navigate([landingRoute]);
  }

  // Modern Dropdown Toggles
  toggleVesselDropdown(event?: Event) {
    if (event) event.stopPropagation();
    this.vesselDropdownOpen = !this.vesselDropdownOpen;
    this.monthDropdownOpen = false;
  }

  toggleMonthDropdown(event?: Event) {
    if (event) event.stopPropagation();
    this.monthDropdownOpen = !this.monthDropdownOpen;
    this.vesselDropdownOpen = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    this.vesselDropdownOpen = false;
    this.monthDropdownOpen = false;
  }

  getFilteredVessels() {
    return this.vesselOptions.filter((opt) =>
      opt.toLowerCase().includes(this.vesselSearchQuery.toLowerCase()),
    );
  }

  getFilteredMonths() {
    return this.monthOptions.filter((opt: any) =>
      opt.toLowerCase().includes(this.monthSearchQuery.toLowerCase()),
    );
  }

  // Vessel Selection
  clearVesselFilter(event?: Event) {
    if (event) event.stopPropagation();
    this.selectedVessels = [];
    this.myreportForm.get('vesselname')?.setValue([]);
    this.filterClick();
  }

  clearDateFilter(event?: Event) {
    if (event) event.stopPropagation();
    this.myreportForm.patchValue({
      from_date: null,
      to_date: null,
    });
    this.filterClick();
  }

  hasActiveFilters(): boolean {
    const f = this.myreportForm.value;
    return !!(
      this.selectedVessels.length > 0 ||
      f?.from_date ||
      f?.to_date
    );
  }

  toggleAllVessels(event: any) {
    const filtered = this.getFilteredVessels();
    if (event.target.checked) {
      const current = new Set(this.selectedVessels);
      filtered.forEach((v) => current.add(v));
      this.selectedVessels = Array.from(current);
    } else {
      const filteredSet = new Set(filtered);
      this.selectedVessels = this.selectedVessels.filter((v) => !filteredSet.has(v));
    }
    this.myreportForm.get('vesselname')?.setValue(this.selectedVessels);
    this.filterClick();
  }

  isAllVesselsSelected() {
    const filtered = this.getFilteredVessels();
    return (
      filtered.length > 0 &&
      filtered.every((v) => this.selectedVessels.includes(v))
    );
  }

  onVesselCheckboxChange(event: any, vessel: string) {
    if (event.target.checked) {
      this.selectedVessels.push(vessel);
    } else {
      this.selectedVessels = this.selectedVessels.filter((v) => v !== vessel);
    }
    this.myreportForm.get('vesselname')?.setValue(this.selectedVessels);
    this.filterClick();
  }

  // Month Selection
  clearMonthFilter(event?: Event) {
    if (event) event.stopPropagation();
    this.myreportForm.get('month')?.setValue('');
  }

  onMonthChange(month: string) {
    this.myreportForm.get('month')?.setValue(month);
    this.monthDropdownOpen = false;
  }

  /** Applies a Light Mode host class so scoped light-theme styles can activate. */
  @HostBinding('class.ch-light') get chLight(): boolean {
    return !this.isDarkMode();
  }

  isDarkMode() {
    return this.requestFormService.isDarkMode();
  }

  clearClick() {
    this.myreportForm.reset({
      vesselname: '',
      from_date: null,
      to_date: null,
    });
    this.selectedVessels = [];
    this.vesselSearchQuery = '';
    this.vesselDropdownOpen = false;
    this.activeSort = { active: '', direction: '' };
    this.fetchReportTableData();
  }

  filterClick(applySort: boolean = true) {
    const from_val = this.myreportForm.get('from_date')?.value;
    const to_val = this.myreportForm.get('to_date')?.value;

    const from_date_str = from_val
      ? this.datePipe.transform(from_val, 'yyyy-MM-dd')
      : null;
    const to_date_str = to_val
      ? this.datePipe.transform(to_val, 'yyyy-MM-dd')
      : null;

    let filteredData = this.tableData.filter((element) => {
      const transformedDate = this.datePipe.transform(
        element.ingested_time,
        'yyyy-MM-dd',
      );

      const fromDateValid =
        !from_date_str || (transformedDate && transformedDate >= from_date_str);
      const toDateValid =
        !to_date_str || (transformedDate && transformedDate <= to_date_str);
      const vesselNameValid =
        this.selectedVessels.length === 0 ||
        (element.ship_name && this.selectedVessels.includes(element.ship_name));

      return fromDateValid && toDateValid && vesselNameValid;
    });

    if (applySort && this.activeSort.active && this.activeSort.direction) {
      const isAsc = this.activeSort.direction === 'asc';
      filteredData.sort((a, b) => {
        const valueA = a[this.activeSort.active];
        const valueB = b[this.activeSort.active];

        if (valueA == null || valueA === '') return isAsc ? 1 : -1;
        if (valueB == null || valueB === '') return isAsc ? -1 : 1;

        if (typeof valueA === 'string' && typeof valueB === 'string') {
          return (
            valueA.localeCompare(valueB, undefined, {
              numeric: true,
              sensitivity: 'base',
            }) * (isAsc ? 1 : -1)
          );
        }

        return (valueA < valueB ? -1 : 1) * (isAsc ? 1 : -1);
      });
    }

    this.elements = filteredData;
    this.currentPage = 0;
    this.paginateData();
  }
  downloadClick() {
    const parseDate = (dateString: any) => {
      const date = new Date(dateString);
      if (!isNaN(date.getTime())) {
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      }
      return '';
    };

    const data = this.paginatedData || this.elements;

    // Header based on your structure
    const csvHeader =
      'S.No,Ship Name,Ship IMO,Report Type,Voyage Month,Ingested Time';

    // Generate CSV rows
    const csvData = data
      .map((element: any, index: number) => {
        const ingested = element.ingested_time
          ? parseDate(element.ingested_time)
          : '';
        return `${index + 1},${element.ship_name},${element.ship_imo},${element.report_type},${element.voyage_month},${ingested}`;
      })
      .join('\n');

    const csvContent = `${csvHeader}\n${csvData}`;

    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'forecast_report_data.csv';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  removeShipPrefix(ship: any) {
    throw new Error('Method not implemented.');
  }

  refreshPageData() {
    this.isLoading = true;

    // API call again to update table
    this.fetchReportTableData();

    // Optional: Reset pagination (so updated data newly appear)
    this.currentPage = 0;

    console.log('Table Refreshed Successfully!');
  }

  getStartIndex(): number {
    if (!this.elements || this.elements.length === 0) return 0;
    return this.currentPage * this.itemsPerPage + 1;
  }

  getEndIndex(): number {
    if (!this.elements || this.elements.length === 0) return 0;
    return Math.min((this.currentPage + 1) * this.itemsPerPage, this.elements.length);
  }
}
